module.exports = window.echarts;